import {
  BuyNGetMMarketingCampaignConfig,
  MARKETING_CAMPAIGN_TARGET_TYPE,
  MarketingCampaignConfigProduct,
  Offer,
} from "../1_types/genericTypes";
import { OFFER_SECTION_KEY } from "../constants";
import { isObjectDefined } from "./object";

type AnyObject = Record<string, any>;

const isObject = (value: unknown): value is AnyObject =>
  isObjectDefined(value) && typeof value === "object";

export const isProductsTarget = (
  target: unknown,
): target is typeof MARKETING_CAMPAIGN_TARGET_TYPE.PRODUCTS =>
  target === MARKETING_CAMPAIGN_TARGET_TYPE.PRODUCTS;

export const isOptionListTarget = (
  target: unknown,
): target is typeof MARKETING_CAMPAIGN_TARGET_TYPE.OPTION_LIST =>
  target === MARKETING_CAMPAIGN_TARGET_TYPE.OPTION_LIST;

export const getOfferConfigProducts = (
  config: Offer["config"] | null | undefined,
): MarketingCampaignConfigProduct[] | undefined => {
  if (!isObject(config)) {
    return undefined;
  }

  const configObject = config as AnyObject;

  if (Array.isArray(configObject.products)) {
    return configObject.products;
  }

  return undefined;
};

export const offerAppliesToProduct = (
  offer: Offer,
  productKey: string,
  sectionKey: string,
): boolean => {
  const offerProducts = getOfferConfigProducts(offer?.config);
  return !!offerProducts?.some(
    (product) =>
      product.productKey === productKey &&
      (product.productSectionKey === sectionKey ||
        sectionKey === OFFER_SECTION_KEY),
  );
};
